import { render, staticRenderFns } from "./ReportedMessages.vue?vue&type=template&id=04e67740&scoped=true"
import script from "./ReportedMessages.vue?vue&type=script&lang=js"
export * from "./ReportedMessages.vue?vue&type=script&lang=js"
import style0 from "./ReportedMessages.vue?vue&type=style&index=0&id=04e67740&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04e67740",
  null
  
)

export default component.exports